export default {
  system_setting: {
    title: '系统配置',
    new_button_title: '新增配置',
    edit_button_title: '编辑配置',
    parent_setting_title: '父配置',
    prop: {
      name: '名称',
      key: 'key',
      data_type: '数据类型',
      data: '数据值',
      is_sensitive: '配置是否是敏感',
      description: '配置描述',
      parent_id: '父配置'
    },
    placeholder: {
      input_key: '输入配置名称，如：app_name',
      input_name: '输入名字，如：应用名称',
      input_description: '输入配置描述，如：应用名称'
    },
    tab: {
      data: '数据值'
    },
    data_types: {
      string: '文本类型',
      number: '数值类型',
      file: '文件类型'
    },
    is_sensitives: {
      true: '是',
      false: '否'
    }
  }
}
